import { footerRow } from './constants';
import { FooterRow, Metric, TVMetric, UseFooterDataProps } from './types';
import { OOHRow } from '../../../../../../../../../api/services/mediaPlanning/offline/oohBudget';

const getRowIdentifier = (item: Partial<OOHRow>) => {
  const getValue = (field: any): string => {
    if (typeof field === 'string') {
      return field;
    }
    if (typeof field === 'object' && field !== null) {
      if ('value' in field) {
        return String(field.value);
      }
      return JSON.stringify(field);
    }
    return String(field);
  };

  return `${getValue(item.format)}${getValue(item.variant)}`;
};

const extractNumericValue = (field: any): number => {
  if (typeof field === 'number') {
    return field;
  }
  if (typeof field === 'object' && field !== null && 'value' in field) {
    return Number(field.value);
  }
  return 0;
};

export const calculateMetrics = (
  calculateFn: (metric: Metric, tvMetric?: TVMetric) => number
): FooterRow => {
  return (Object.keys(footerRow) as Metric[]).reduce(
    (totals: FooterRow, metric) => {
      const newTotals = { ...totals };
      newTotals[metric] = calculateFn(metric);
      return newTotals;
    },
    footerRow
  );
};

export const calculateOptional = (
  key: keyof OOHRow,
  rows: UseFooterDataProps['rows'],
  optionalIds: UseFooterDataProps['optionalIds']
) =>
  rows?.reduce((acc, item) => {
    const touchpointId = getRowIdentifier(item);
    const value = extractNumericValue(item[key]); // Handle numeric extraction
    return !item.isRequired && optionalIds[touchpointId] ? acc + value : acc;
  }, 0);

export const calculateMustHaveTotal = (
  key: keyof OOHRow,
  rows: UseFooterDataProps['rows'],
  mustHaveIds: Record<number, boolean>
) =>
  rows?.reduce((acc, item) => {
    const touchpointId = getRowIdentifier(item);
    const value = extractNumericValue(item[key]); // Handle numeric extraction
    return Object.keys(mustHaveIds).includes(String(touchpointId))
      ? acc + value
      : acc;
  }, 0);

export const getRowIdsByPriority = (
  rows: OOHRow[],
  isMustHave: boolean,
  checked = false
) =>
  rows.reduce((acc, item) => {
    if (item.isRequired === isMustHave) {
      const rowId = getRowIdentifier(item);
      return { ...acc, [rowId]: checked };
    }
    return acc;
  }, {} as Record<number | string, boolean>);
